var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnBackgroundIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 767,
    height: 705,
    viewBox: "0 0 767 705",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.511 245.445L362.368 246.139C360.546 247.242 358.826 248.477 357.223 249.825L360.531 247.497H388.604L393.708 286.146L368.187 311.667L342.666 329.404V349.856C342.666 364.143 350.133 377.388 362.353 384.789L389.221 401.051L332.458 434.167H321.509L301.103 421.815C288.883 414.419 281.416 401.168 281.416 386.882V318.103C281.416 303.811 288.889 290.561 301.118 283.165L362.368 246.114C362.746 245.884 363.129 245.66 363.511 245.445Z",
    fill: "url(#paint0_radial_1944_2087)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M424.333 326.977V349.843C424.333 364.13 416.866 377.375 404.646 384.776L343.396 421.853C330.866 429.438 315.278 429.713 302.527 422.675L362.358 458.889C375.359 466.759 391.651 466.759 404.646 458.889L465.896 421.812C478.116 414.416 485.583 401.166 485.583 386.879V370.362L480.479 362.706L424.333 326.977Z",
    fill: "url(#paint1_radial_1944_2087)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M465.881 283.164L404.631 246.113C392.039 238.497 376.364 238.263 363.578 245.403L362.368 246.143C350.139 253.539 342.666 266.795 342.666 281.081V329.489L362.368 317.571C375.363 309.711 391.641 309.711 404.636 317.571L465.886 354.622C477.732 361.788 485.113 374.447 485.562 388.223C485.578 387.779 485.583 387.335 485.583 386.886V318.102C485.583 303.815 478.11 290.56 465.881 283.164Z",
    fill: "url(#paint2_radial_1944_2087)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.25 20C279.49 20 274.776 20.9376 270.378 22.7594C265.98 24.5811 261.984 27.2513 258.617 30.6174C255.251 33.9835 252.581 37.9797 250.759 42.3777C248.938 46.7758 248 51.4896 248 56.25C248 61.0104 248.938 65.7242 250.759 70.1223C252.581 74.5203 255.251 78.5165 258.617 81.8826C261.984 85.2487 265.98 87.9189 270.378 89.7406C274.776 91.5624 279.49 92.5 284.25 92.5C289.01 92.5 293.724 91.5624 298.122 89.7406C302.52 87.9189 306.516 85.2487 309.883 81.8826C313.249 78.5165 315.919 74.5203 317.741 70.1223C319.562 65.7242 320.5 61.0104 320.5 56.25C320.5 51.4896 319.562 46.7758 317.741 42.3777C315.919 37.9797 313.249 33.9835 309.883 30.6174C306.516 27.2513 302.52 24.5811 298.122 22.7594C293.724 20.9376 289.01 20 284.25 20Z",
    fill: "#084593"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M263.388 39.9291C260.088 38.6666 256.505 37.9766 252.762 37.9766C236.325 37.9766 223 51.3016 223 67.7391C223 73.9291 224.892 79.6741 228.125 84.4341C228.277 84.3691 269.237 67.2116 294.14 57.2141C280.38 48.9191 267.758 41.6016 263.388 39.9291Z",
    fill: "#0556AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342.997 73.4347C342.997 60.1422 332.222 49.3672 318.929 49.3672C316.437 49.3672 314.034 49.7472 311.772 50.4497C309.282 51.2247 302.642 53.8047 294.137 57.2197C315.079 69.8447 338.612 84.7097 339.767 85.4397C341.809 81.9022 342.997 77.8097 342.997 73.4347Z",
    fill: "#18B0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M339.774 85.4388C338.617 84.7087 315.087 69.8438 294.144 57.2188C269.239 67.2137 228.279 84.3712 228.127 84.4362C229.169 85.9712 237.069 97.5013 252.762 97.5013C265.337 97.5013 293.202 97.5013 318.647 97.5013C332.174 97.5013 338.372 87.8663 339.774 85.4388Z",
    fill: "#2CCEFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.36 145C100.953 145 99 146.952 99 149.36V230.643C99 233.048 100.953 235 103.358 235H151.5V145H103.36Z",
    fill: "#D56EFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M169.64 145H151.5V167.507H174V149.36C174 146.952 172.048 145 169.64 145Z",
    fill: "#B854E5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 212.633V234.998H169.642C172.048 234.998 174 233.045 174 230.64V212.635L151.5 212.633Z",
    fill: "#5E25A0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 167.508H174V190.013H151.5V167.508Z",
    fill: "#A23ADF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 190.016H174V212.641H151.5V190.016Z",
    fill: "#8026D1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.798 215H78.2025C75.8825 215 74 213.118 74 210.798V169.202C74 166.882 75.8825 165 78.2025 165H119.798C122.118 165 124 166.882 124 169.202V210.798C124 213.118 122.118 215 119.798 215Z",
    fill: "#6517A3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.252 177.5V195.982L93.4471 177.5H87.9746V202.5H92.7471V183.875L104.645 202.5H110.025V177.5H105.252Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1895 341.257C54.1895 341.257 56.2245 333.12 65.917 332.76H95.3595C95.3595 332.76 86.862 332.042 85.187 321.75C83.512 311.457 79.0844 307.387 72.8594 307.267C66.6369 307.147 63.7645 313.73 63.0445 316.005C62.327 318.28 54.1895 341.257 54.1895 341.257Z",
    fill: "url(#paint3_linear_1944_2087)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0845 366.153L63.1645 315.528C63.1645 315.528 66.037 307.031 72.8595 307.271H35.0395C35.0395 307.271 28.577 307.271 23.9095 314.691C23.9095 314.691 16.7295 324.026 12.5395 343.176C8.3495 362.326 10.027 363.401 10.027 363.401C10.027 363.401 8.9495 373.933 25.107 373.096H37.5545C37.5545 373.096 45.092 373.213 48.0845 366.153Z",
    fill: "url(#paint4_linear_1944_2087)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M72.2169 309.766L78.3944 308.756C76.9044 307.861 75.1194 307.396 73.2694 307.296L72.7719 307.268C72.7619 307.268 72.7544 307.268 72.7444 307.266C72.7044 307.266 72.6669 307.271 72.6244 307.271C72.1869 307.268 71.7744 307.308 71.3694 307.368C71.1969 307.393 71.0294 307.426 70.8644 307.461C70.6019 307.518 70.3494 307.591 70.1019 307.671C68.9719 308.043 67.9819 308.636 67.1369 309.363C66.8444 309.618 66.5744 309.886 66.3144 310.163C64.4119 312.191 63.3594 314.746 62.9644 315.998C62.8669 316.311 62.6169 317.038 62.2794 318.018L56.7344 336.628C56.9494 336.398 57.2294 336.181 57.4769 335.956C57.6169 335.828 57.7469 335.698 57.8969 335.576C58.1169 335.396 58.3469 335.228 58.5894 335.056C59.0044 334.761 59.4419 334.478 59.9319 334.223C59.9944 334.191 60.0394 334.148 60.1044 334.116L65.4319 316.231C65.4344 316.238 67.6644 309.966 72.2169 309.766Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M72.1595 308.515L75.8495 307.665C75.8495 307.665 74.1345 307.225 72.7195 307.278C71.6695 307.315 70.7145 307.458 69.852 307.785C69.7845 307.813 69.712 307.833 69.6445 307.863C69.442 307.945 69.247 308.045 69.0545 308.143C68.912 308.218 68.767 308.29 68.6295 308.37C68.5095 308.44 68.3945 308.515 68.277 308.59C68.0645 308.73 67.8545 308.875 67.6545 309.03C67.612 309.063 67.572 309.095 67.532 309.128C66.4595 309.993 65.5995 311.045 64.9345 312.048C64.9195 312.07 64.9045 312.09 64.892 312.113C64.8195 312.223 64.7595 312.328 64.692 312.438C63.837 313.843 63.302 315.198 63.047 316.008C63.002 316.153 62.922 316.388 62.8195 316.693L56.877 336.638C57.327 336.153 57.847 335.675 58.442 335.23L64.2045 315.885C64.212 315.855 66.7095 308.728 72.1595 308.515Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1856 364.516C66.1856 364.516 64.1506 372.653 54.4581 373.013H25.0156C25.0156 373.013 33.5131 373.731 35.1881 384.023C36.8631 394.316 41.2906 398.386 47.5156 398.506C53.7406 398.626 56.6106 392.043 57.3306 389.768C58.0481 387.496 66.1856 364.516 66.1856 364.516Z",
    fill: "url(#paint5_linear_1944_2087)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M48.1365 395.925L41.959 396.935C43.449 397.83 45.234 398.295 47.084 398.395L47.5815 398.422C47.5915 398.422 47.599 398.423 47.609 398.425C47.649 398.425 47.6865 398.42 47.729 398.42C48.1665 398.422 48.579 398.383 48.984 398.323C49.1565 398.298 49.324 398.265 49.489 398.23C49.7515 398.172 50.004 398.1 50.2515 398.02C51.3815 397.647 52.3715 397.055 53.2165 396.327C53.509 396.073 53.779 395.805 54.039 395.528C55.9415 393.5 56.994 390.945 57.389 389.693C57.4865 389.38 57.7365 388.652 58.074 387.672L63.619 369.062C63.404 369.293 63.124 369.51 62.8765 369.735C62.7365 369.862 62.6065 369.992 62.4565 370.115C62.2365 370.295 62.0065 370.462 61.764 370.635C61.349 370.93 60.9115 371.212 60.4215 371.467C60.359 371.5 60.314 371.542 60.249 371.575L54.9215 389.46C54.9215 389.452 52.6915 395.725 48.1365 395.925Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M48.1959 397.177L44.5059 398.027C44.5059 398.027 46.2209 398.467 47.6359 398.415C48.6859 398.377 49.6409 398.235 50.5034 397.907C50.5709 397.88 50.6434 397.86 50.7109 397.83C50.9134 397.747 51.1084 397.647 51.3009 397.55C51.4434 397.475 51.5884 397.402 51.7259 397.322C51.8459 397.252 51.9609 397.177 52.0784 397.102C52.2909 396.962 52.5009 396.817 52.7009 396.662C52.7434 396.63 52.7834 396.597 52.8234 396.565C53.8959 395.7 54.7559 394.647 55.4209 393.645C55.4359 393.622 55.4509 393.602 55.4634 393.58C55.5359 393.47 55.5959 393.365 55.6634 393.255C56.5184 391.85 57.0534 390.495 57.3084 389.685C57.3534 389.54 57.4334 389.305 57.5359 389L63.4784 369.055C63.0284 369.54 62.5084 370.017 61.9134 370.462L56.1509 389.807C56.1434 389.84 53.6459 396.965 48.1959 397.177Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2881 339.623L57.1131 390.28C57.1131 390.28 54.3356 398.745 47.5156 398.505H85.3356C85.3356 398.505 91.7981 398.505 96.4656 391.085C96.4656 391.085 103.646 381.75 107.836 362.6C112.026 343.45 110.348 342.375 110.348 342.375C110.348 342.375 111.426 331.843 95.2681 332.68H82.8206C82.8206 332.68 75.2806 332.563 72.2881 339.623Z",
    fill: "url(#paint6_linear_1944_2087)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M169.64 470H103.36C100.953 470 99 471.952 99 474.36V492.507H174V474.36C174 471.952 172.048 470 169.64 470Z",
    fill: "#2D92D4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99 537.633V555.638C99 558.045 100.953 559.998 103.358 559.998H169.64C172.048 559.998 174 558.045 174 555.638V537.633H99Z",
    fill: "#2150A9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99 492.508H174V515.013H99V492.508Z",
    fill: "#2D83D4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M99 515.016H174V537.641H99V515.016Z",
    fill: "#2E70C9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M119.798 540H78.2025C75.8825 540 74 538.118 74 535.798V494.202C74 491.882 75.8825 490 78.2025 490H119.798C122.118 490 124 491.882 124 494.202V535.798C124 538.118 122.118 540 119.798 540Z",
    fill: "#00488D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M110.007 502.5L106.142 520.66L101.859 502.5H96.3916L91.9741 521.222L87.9916 502.5H83.1016L88.9616 527.5H94.8416L99.1241 508.278L103.409 527.5H109.037L114.897 502.5H110.007Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M280.5 595C263.933 595 250.5 608.433 250.5 625C250.5 641.568 263.933 655 280.5 655C297.068 655 310.5 641.568 310.5 625C310.5 608.433 297.068 595 280.5 595Z",
    fill: "url(#paint7_linear_1944_2087)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M306.75 625C292.253 625 280.5 636.753 280.5 651.25C280.5 665.747 292.253 677.5 306.75 677.5C321.247 677.5 333 665.747 333 651.25C333 636.753 321.247 625 306.75 625Z",
    fill: "url(#paint8_linear_1944_2087)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M283 655C271.955 655 263 663.955 263 675C263 686.045 271.955 695 283 695C294.045 695 303 686.045 303 675C303 663.955 294.045 655 283 655Z",
    fill: "url(#paint9_linear_1944_2087)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M278.798 617.5H251.482C250.865 619.903 250.5 622.405 250.5 625C250.5 641.567 263.933 655 280.5 655C280.6 655 280.695 654.985 280.795 654.985C280.802 655.032 280.81 655.077 280.818 655.125C270.8 656.212 263 664.693 263 675C263 675.847 263.07 676.68 263.173 677.5H278.798C283.88 677.5 288 673.38 288 668.298V626.702C288 621.62 283.88 617.5 278.798 617.5Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M263 675.003H278.532C282.842 675.003 286.335 671.511 286.335 667.201V626.138C286.335 621.828 282.842 618.336 278.532 618.336H251.27C250.78 620.483 250.5 622.708 250.5 625.003C250.5 641.571 263.933 655.003 280.5 655.003C280.6 655.003 280.695 654.988 280.795 654.988C280.802 655.036 280.81 655.081 280.818 655.128C270.8 656.216 263 664.696 263 675.003Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M278.265 619.164H251.077C250.705 621.052 250.5 622.999 250.5 624.997C250.5 641.564 263.933 654.997 280.5 654.997C280.6 654.997 280.695 654.982 280.795 654.982C280.802 655.029 280.81 655.074 280.818 655.122C271.625 656.122 264.317 663.349 263.175 672.497H278.268C281.803 672.497 284.667 669.632 284.667 666.097V625.564C284.667 622.029 281.8 619.164 278.265 619.164Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M278 670H238C235.237 670 233 667.763 233 665V625C233 622.237 235.237 620 238 620H278C280.763 620 283 622.237 283 625V665C283 667.763 280.763 670 278 670Z",
    fill: "url(#paint10_linear_1944_2087)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M249.083 656.875V651.13C250.148 652.003 255.06 653.75 256.333 653.75C257.08 653.75 261.678 653.97 261.678 651.148C261.678 647.065 248.973 647.413 248.973 639.335C248.973 637.995 249.138 631.688 259.305 631.688C261.908 631.688 264.983 632.34 265.875 632.675V638.042C265.435 637.742 263.65 636.248 259.635 636.248C254.943 636.248 254.535 638.455 254.535 638.85C254.535 642.248 267.03 642.71 267.03 650.628C267.03 658.558 257.995 658.313 256.588 658.313C255.145 658.313 250.038 657.355 249.083 656.875Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M444 60C444 84.8525 464.147 105 489 105C513.853 105 534 84.8525 534 60H489H444Z",
    fill: "#D35230"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M489 15V60H534C534 35.1475 513.853 15 489 15Z",
    fill: "#FF8F6B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M489 15C464.147 15 444 35.1475 444 60H489V15Z",
    fill: "#ED6C47"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M489 41.7025C489 36.62 484.88 32.5 479.798 32.5H453.435C447.543 40.11 444 49.63 444 60C444 72.79 449.363 84.3075 457.927 92.5H479.795C484.88 92.5 489 88.38 489 83.2975V41.7025Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M479.532 33.3359H452.812C447.3 40.8059 444 50.0084 444 60.0034C444 71.5459 448.383 82.0384 455.528 90.0034H479.532C483.842 90.0034 487.335 86.5109 487.335 82.2009V41.1384C487.333 36.8309 483.84 33.3359 479.532 33.3359Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M479.265 34.1641H452.19C447.045 41.4791 444 50.3741 444 59.9966C444 70.3666 447.543 79.8866 453.435 87.4966H479.265C482.8 87.4966 485.665 84.6316 485.665 81.0966V40.5641C485.667 37.0291 482.8 34.1641 479.265 34.1641Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M479 85H439C436.237 85 434 82.7625 434 80V40C434 37.2375 436.237 35 439 35H479C481.763 35 484 37.2375 484 40V80C484 82.7625 481.763 85 479 85Z",
    fill: "url(#paint11_linear_1944_2087)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M460.683 47.5312H449V72.5312H454.06V63.7288H459.75C464.44 63.7288 468.243 59.9263 468.243 55.2363V55.0913C468.243 50.9163 464.858 47.5312 460.683 47.5312ZM462.925 55.8963C462.925 58.0438 461.183 59.7863 459.035 59.7863H454.06V51.4738H459.035C461.183 51.4738 462.925 53.2163 462.925 55.3638V55.8963Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M693 185V205C693 213.285 686.285 220 678 220C669.715 220 663 213.285 663 205V180H688C690.763 180 693 182.237 693 185ZM678 170C683.523 170 688 165.523 688 160C688 154.477 683.523 150 678 150C672.477 150 668 154.477 668 160C668 165.523 672.477 170 678 170Z",
    fill: "#5059C9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M670.5 185V212.5C670.5 226.857 658.397 238.39 643.835 237.445C630.547 236.585 620.5 224.958 620.5 211.643V180H665.5C668.263 180 670.5 182.237 670.5 185ZM645.5 172.5C653.785 172.5 660.5 165.785 660.5 157.5C660.5 149.215 653.785 142.5 645.5 142.5C637.215 142.5 630.5 149.215 630.5 157.5C630.5 165.785 637.215 172.5 645.5 172.5Z",
    fill: "#7B83EB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M645.5 172.5C653.784 172.5 660.5 165.784 660.5 157.5C660.5 149.216 653.784 142.5 645.5 142.5C637.216 142.5 630.5 149.216 630.5 157.5C630.5 165.784 637.216 172.5 645.5 172.5Z",
    fill: "#7B83EB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M648 213.298V180H620.5V211.643C620.5 215.478 621.358 219.162 622.86 222.5H638.795C643.88 222.5 648 218.38 648 213.298Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M620.5 180V211.643C620.5 214.543 621.002 217.353 621.885 220H638.53C642.84 220 646.333 216.508 646.333 212.198V180H620.5Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M644.667 180H620.5V211.643C620.5 213.648 620.753 215.603 621.185 217.5H638.265C641.8 217.5 644.665 214.635 644.665 211.1L644.667 180Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M638 215H598C595.237 215 593 212.763 593 210V170C593 167.237 595.237 165 598 165H638C640.763 165 643 167.237 643 170V210C643 212.763 640.763 215 638 215Z",
    fill: "url(#paint12_linear_1944_2087)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M628.168 177.5H607.828V181.8H615.446V202.5H620.551V181.8H628.168V177.5Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M695.043 374.256L721.088 400.124C722.393 401.421 724.52 401.324 725.705 399.916C730.575 394.131 741.66 379.586 741.66 367.031L701.688 356.531L695.043 374.256Z",
    fill: "url(#paint13_linear_1944_2087)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M694.656 331.783L721.264 305.175C722.336 304.103 724.071 304.118 725.106 305.225C729.109 309.505 738.199 320.598 741.756 336.31L695.811 348.35L694.656 331.783Z",
    fill: "url(#paint14_linear_1944_2087)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M703.901 344.787L750.601 332.199C752.094 331.797 753.621 332.674 754.004 334.172C754.859 337.539 756.106 343.989 756.106 352.974C756.106 361.967 754.816 368.419 753.931 371.784C753.539 373.279 752.004 374.142 750.514 373.729L694.559 358.177L703.901 344.787Z",
    fill: "url(#paint15_linear_1944_2087)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M697.009 333H694.666L695.041 374.26L698.541 377.735C700.544 377.088 702.001 375.227 702.001 373.007V337.99C702.001 335.235 699.766 333 697.009 333Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M695.041 374.26L705.809 384.955C709.404 383.703 712.001 380.32 712.001 376.298V334.702C712.001 329.62 707.881 325.5 702.799 325.5H700.939L694.656 331.782L695.041 374.26Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M695.041 374.263L703.721 382.883C707.461 382.308 710.336 379.103 710.336 375.201V334.138C710.336 329.828 706.844 326.336 702.534 326.336H700.106L694.656 331.786L695.041 374.263Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M695.041 374.257L701.324 380.497H702.266C705.801 380.497 708.666 377.632 708.666 374.097V333.564C708.666 330.029 705.801 327.164 702.266 327.164H699.271L694.656 331.779L695.041 374.257Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M702 378H662C659.237 378 657 375.763 657 373V333C657 330.237 659.237 328 662 328H702C704.763 328 707 330.237 707 333V373C707 375.763 704.763 378 702 378Z",
    fill: "url(#paint16_linear_1944_2087)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M691.558 339.548C690.37 338.903 688.888 339.343 688.243 340.528L682.125 351.97L675.753 340.528C675.108 339.34 673.623 338.903 672.438 339.548C671.25 340.193 670.813 341.678 671.458 342.863L679.143 356.823V364.03C679.143 365.533 680.363 366.753 681.865 366.753C683.368 366.753 684.588 365.533 684.588 364.03V357.358L692.54 342.863C693.183 341.675 692.745 340.193 691.558 339.548Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M691.138 513.871L674.113 503.953V532.938H693.001V517.111C693.001 515.776 692.291 514.543 691.138 513.871Z",
    fill: "#103262"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M615.5 480H640.5V502.5H615.5V480Z",
    fill: "#0084D7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M640.5 480H665.5V502.5H640.5V480Z",
    fill: "#33AFEC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M665.5 480H690.5V502.5H665.5V480Z",
    fill: "#54DAFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M640.5 502.5H665.5V525H640.5V502.5Z",
    fill: "#027AD4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M640.5 525H665.5V547.5H640.5V525Z",
    fill: "#0553A4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M665.5 502.5H690.5V525H665.5V502.5Z",
    fill: "#25A2E5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M665.5 525H690.5V547.5H665.5V525Z",
    fill: "#0262B8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.019,
    d: "M615.5 547.499H690.5V515.594L655.475 535.594L615.5 515.594V547.499Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.038,
    d: "M615.5 547.498H690.5V516.188L655.475 536.188L615.5 516.188V547.498Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.057,
    d: "M615.5 547.496H690.5V516.781L655.475 536.781L615.5 516.781V547.496Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.076,
    d: "M615.5 547.503H690.5V517.383L655.475 537.383L615.5 517.383V547.503Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.095,
    d: "M615.5 547.502H690.5V517.977L655.475 537.977L615.5 517.977V547.502Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.114,
    d: "M615.5 547.498H690.5V518.57L655.475 538.57L615.5 518.57V547.498Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.133,
    d: "M615.5 547.497H690.5V519.164L655.475 539.164L615.5 519.164V547.497Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.152,
    d: "M615.5 547.503H690.5V519.766L655.475 539.766L615.5 519.766V547.503Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.171,
    d: "M615.5 547.502H690.5V520.359L655.475 540.359L615.5 520.359V547.502Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.191,
    d: "M615.5 547.501H690.5V520.953L655.475 540.953L615.5 520.953V547.501Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.209,
    d: "M615.5 547.499H690.5V521.547L655.475 541.547L615.5 521.547V547.499Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229,
    d: "M615.5 547.498H690.5V522.141L655.475 542.141L615.5 522.141V547.498Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.248,
    d: "M615.5 547.497H690.5V522.734L655.475 542.734L615.5 522.734V547.497Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.267,
    d: "M615.5 547.503H690.5V523.336L655.475 543.336L615.5 523.336V547.503Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.286,
    d: "M615.5 547.502H690.5V523.93L655.475 543.93L615.5 523.93V547.502Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.305,
    d: "M615.5 547.498H690.5V524.523L655.475 544.523L615.5 524.523V547.498Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.324,
    d: "M615.5 547.497H690.5V525.117L655.475 545.117L615.5 525.117V547.497Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.343,
    d: "M615.5 547.504H690.5V525.719L655.475 545.719L615.5 525.719V547.504Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.362,
    d: "M615.5 547.502H690.5V526.312L655.475 546.312L615.5 526.312V547.502Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M615.5 547.501H690.5V526.906L655.475 546.906L615.5 526.906V547.501Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M615.5 547.5H690.5V527.5L655.475 547.5L615.5 527.5V547.5Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M621.602 560.002H688.009C690.769 560.002 693.007 557.779 693.009 555.017C693.017 543.714 692.999 517.109 692.999 517.109C692.999 517.109 692.982 517.664 688.622 520.139C684.262 522.614 619.859 558.917 619.859 558.917C619.859 558.917 620.444 560.002 621.602 560.002Z",
    fill: "url(#paint17_linear_1944_2087)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 480H615.5V475C615.5 472.237 617.737 470 620.5 470H685.5C688.262 470 690.5 472.237 690.5 475V480Z",
    fill: "url(#paint18_linear_1944_2087)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M615.5 517.5V555C615.5 557.763 617.738 560 620.5 560H658H688.01C689.165 560 690.218 559.595 691.062 558.938L615.5 517.5Z",
    fill: "url(#paint19_linear_1944_2087)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M636.298 487.5H615.5V547.5H636.298C641.38 547.5 645.5 543.38 645.5 538.298V496.702C645.5 491.62 641.38 487.5 636.298 487.5Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M636.033 545.003H615.5V488.336H636.033C640.343 488.336 643.835 491.828 643.835 496.138V537.201C643.833 541.511 640.34 545.003 636.033 545.003Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M635.765 542.497H615.5V489.164H635.765C639.3 489.164 642.165 492.029 642.165 495.564V536.097C642.168 539.632 639.3 542.497 635.765 542.497Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M635.5 540H595.5C592.737 540 590.5 537.763 590.5 535V495C590.5 492.237 592.737 490 595.5 490H635.5C638.263 490 640.5 492.237 640.5 495V535C640.5 537.763 638.263 540 635.5 540Z",
    fill: "url(#paint20_linear_1944_2087)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M615.5 501.727C607.722 501.727 603.037 507.669 603.037 514.999C603.037 522.329 607.705 528.272 615.5 528.272C623.297 528.272 627.962 522.329 627.962 515.002C627.962 507.669 623.277 501.727 615.5 501.727ZM615.5 523.792C611.087 523.792 608.45 519.857 608.45 515.002C608.45 510.147 611.1 506.212 615.5 506.212C619.9 506.212 622.552 510.149 622.552 515.002C622.552 519.854 619.91 523.792 615.5 523.792Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M534 622.5H494V645H534V622.5Z",
    fill: "#21A366"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M534 645H454V685C454 687.763 456.237 690 459 690H529C531.762 690 534 687.763 534 685V645Z",
    fill: "#185C37"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M534 645H494V667.5H534V645Z",
    fill: "#107C42"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M494 622.5H454V645H494V622.5Z",
    fill: "#3FA071"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M529 600H494V622.5H534V605C534 602.237 531.763 600 529 600Z",
    fill: "#33C481"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M459 600H494V622.5H454V605C454 602.237 456.237 600 459 600Z",
    fill: "#21A366"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M479.798 617.5H454V677.5H479.798C484.88 677.5 489 673.38 489 668.298V626.702C489 621.62 484.88 617.5 479.798 617.5Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M479.532 675.003H454V618.336H479.532C483.842 618.336 487.335 621.828 487.335 626.138V667.201C487.333 671.511 483.84 675.003 479.532 675.003Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M479.265 672.497H454V619.164H479.265C482.8 619.164 485.665 622.029 485.665 625.564V666.097C485.668 669.632 482.8 672.497 479.265 672.497Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M479 670H439C436.237 670 434 667.763 434 665V625C434 622.237 436.237 620 439 620H479C481.763 620 484 622.237 484 625V665C484 667.763 481.763 670 479 670Z",
    fill: "url(#paint21_linear_1944_2087)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M448.517 632.5H454.482L459.322 641.885L464.437 632.5H470.009L462.332 645L470.184 657.5H464.307L459.032 647.675L453.779 657.5H447.814L455.797 644.955L448.517 632.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1944_2087",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(349.998 284.202) rotate(110.528) scale(159.916 278.925)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#BF8AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#3079D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11408C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1944_2087",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(314.048 415.377) rotate(-8.36713) scale(158.486 104.691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#BF8AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#591C96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1944_2087",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(470.493 365.512) rotate(-165.772) scale(151.38 254.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3079D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11408C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1944_2087",
    x1: 45.447,
    y1: 308.512,
    x2: 93.0794,
    y2: 346.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0837C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#0B4BCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#1071DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#127FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1944_2087",
    x1: 21.5245,
    y1: 385.161,
    x2: 52.1645,
    y2: 296.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#F1C609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#DCC319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#BABE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#8CB754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#50AE7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#43AC89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#41AD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#37B0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#30B2DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#2CB4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1944_2087",
    x1: 23.4506,
    y1: 381.873,
    x2: 67.9706,
    y2: 381.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#FFB055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#EB7447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#DF4E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA403C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1944_2087",
    x1: 72.1856,
    y1: 401.678,
    x2: 92.7706,
    y2: 323.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#F36284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#A355E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1944_2087",
    x1: 263.362,
    y1: 601.07,
    x2: 288.942,
    y2: 636.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03676A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1944_2087",
    x1: 290.805,
    y1: 631.54,
    x2: 325.558,
    y2: 674.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18939A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#168C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#117981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1944_2087",
    x1: 263,
    y1: 675,
    x2: 303,
    y2: 675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37C6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37C6D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1944_2087",
    x1: 234.465,
    y1: 621.465,
    x2: 281.535,
    y2: 668.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#027074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1944_2087",
    x1: 435.465,
    y1: 36.465,
    x2: 480.925,
    y2: 81.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA4E2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B63016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1944_2087",
    x1: 594.62,
    y1: 166.62,
    x2: 641.508,
    y2: 213.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5961C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A41AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1944_2087",
    x1: 712.518,
    y1: 393.131,
    x2: 720.153,
    y2: 365.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0358A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#0358A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1944_2087",
    x1: 708.329,
    y1: 314.48,
    x2: 717.449,
    y2: 337.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1944_2087",
    x1: 725.029,
    y1: 364.934,
    x2: 723.864,
    y2: 397.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F78D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F78D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1944_2087",
    x1: 658.57,
    y1: 329.57,
    x2: 706.513,
    y2: 377.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B65C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1944_2087",
    x1: 680.312,
    y1: 516.394,
    x2: 663.714,
    y2: 545.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31ABEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1582D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1944_2087",
    x1: 617.163,
    y1: 472.48,
    x2: 686.213,
    y2: 477.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#076DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0461AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1944_2087",
    x1: 653.383,
    y1: 538.045,
    x2: 642.095,
    y2: 557.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33ACEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B8EDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1944_2087",
    x1: 591.825,
    y1: 491.325,
    x2: 639.025,
    y2: 538.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0864C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1944_2087",
    x1: 435.813,
    y1: 621.813,
    x2: 481.637,
    y2: 667.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6731"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBackgroundIcons);
export default __webpack_public_path__ + "static/media/on-background-icons.679dae0bd2f26c98ab756bc9e11aeeff.svg";
export { ForwardRef as ReactComponent };